import gql from 'graphql-tag';
import { CHOICE_TYPE } from './ChoiceType.gql';

export const CHOICE_SUBSCRIPTION = gql`
  ${CHOICE_TYPE}
  subscription surveyQuestionChoiceSubscription {
    surveyQuestionChoiceSubscription {
      mutation
      choice {
        ...ChoiceType
      }
    }
  }
`; 